export const version = '1.0.1';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  navbarPosition: 'double-top',
  showBurgerMenu: true, // controls showing vertical nav on mobile
  currency: 'R',
  isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
  navbarStyle: 'transparent',
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };
